import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { AuthState } from '@app/core/states/auth.state';
import { Select } from '@ngxs/store';
import { Observable } from 'rxjs';

@Component({
  selector: 'rk-share-marketing-shell',
  templateUrl: './share-marketing-shell.component.html',
  styleUrls: ['./share-marketing-shell.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ShareMarketingShellComponent implements OnInit {
  @Input() title: string;
  @Input() img: string;
  @Input() ctaText: string;
  @Input() theme: string;
  @Output() readonly ctaAction = new EventEmitter();

  @Select(AuthState.userLang)
  userLang$: Observable<string>;

  lang = 'en';

  ngOnInit() {
    this.userLang$.subscribe(v => {
      this.lang = ['en', 'en-gb', 'fr'].indexOf(v) > -1 ? v : 'en-eu';
    });
  }
}
